import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMount, useSearchParam } from "react-use";
import { useStores } from "../hooks";
import Header from "../component/Header";
import Footer from "../component/Footer";
import Locker from "../component/Locker";
import TakeItem from "../component/TakeItem";
import UserInfo from "../component/UserInfo";
import CountDown from "../component/CountDown";
import { procTake, openDoor } from "../service";
import { SvBook } from "../graphql";

const Book = () => {
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  const [bookID, setBookID] = useState<number>(0);
  const [book, setBook] = useState<SvBook>();
  const [takeError, setTakeError] = useState<string>("");
  const [takeSuccess, setTakeSuccess] = useState<boolean>(false);
  const [takeProcess, setTakeProcess] = useState<boolean>(false);

  const id = useSearchParam("id");

  useMount(() => {
    if (id) {
      const bid = parseInt(id);
      handleBookData(bid);
    }
  });

  const handleBookData = (bid: number) => {
    setBookID(bid);
    sessionStore.items.forEach((item) => {
      if (item.id === bid) {
        setBook(item);
      }
    });
  };

  const handleTake = async () => {
    setTakeProcess(true);
    if (bookID === 0) {
      setTakeError(formatMessage({ id: "hyvendor.error.noselected" }));
    } else {
      procTake(bookID)
        .then((res) => {
          if (res.success) {
            if (book) {
              sessionStore.takeitem = book;
              const ldid: number = book.locker_detail_id!;
              if (sessionStore.debug) {
                setTakeSuccess(true);
              } else {
                openDoor(ldid)
                  .then((flag) => {
                    if (!flag) {
                      console.error("hyvendor.error.syserror");
                    }
                  })
                  .finally(() => {
                    setTakeSuccess(true);
                  });
              }
            }
          } else {
            setTakeError(res.message);
          }
        })
        .finally(() => {
          setTakeProcess(false);
        });
    }
  };

  return (
    <>
      {takeSuccess ? (
        <Navigate to="/open" />
      ) : (
        <>
          <div
            className="overlay"
            style={{ display: takeError !== "" ? "block" : "none" }}
          >
            <div className="info">
              <section className="error">{takeError}</section>
              <div className="btns">
                <button
                  type="button"
                  className="btn confirm"
                  onClick={(e) => {
                    setTakeError("");
                    setTakeProcess(false);
                  }}
                >
                  {formatMessage({ id: "hyvendor.button.ok" })}
                </button>
              </div>
            </div>
          </div>
          <div className="page-set">
            <Header />
            <div className="Main">
              {sessionStore.isLogin && (
                <>
                  <UserInfo reader={sessionStore.userInfo} />
                  <section className="Menu"></section>
                </>
              )}
              <h3 className="Title">
                <span>{formatMessage({ id: "hyvendor.title.book" })}</span>
                <em>{formatMessage({ id: "hyvendor.message.book" })}</em>
              </h3>
              <CountDown />
              <Locker
                list={sessionStore.lockerDetail}
                tier={sessionStore.lockerTier}
                column={sessionStore.lockerColumn}
                items={sessionStore.lockerItems}
                selected={book}
                handleSelected={handleBookData}
              />
              <section className="book-box">
                <TakeItem item={book} />
                <section className="btns">
                  {sessionStore.isLogin ? (
                    <button
                      type="button"
                      className="btn next"
                      onClick={handleTake}
                      disabled={takeProcess}
                    >
                      {formatMessage({ id: "hyvendor.button.take" })}
                    </button>
                  ) : (
                    <Link
                      className="order"
                      to="/login"
                      state={{
                        from: "/book" + (bookID !== 0 ? "?id=" + bookID : ""),
                      }}
                    >
                      <button type="button" className="btn next">
                        {formatMessage({ id: "hyvendor.button.login" })}
                      </button>
                    </Link>
                  )}
                  &nbsp;
                  <Link to="/logout">
                    <button type="button" className="btn cancel">
                      {formatMessage({ id: "hyvendor.button.cancelexit" })}
                    </button>
                  </Link>
                </section>
              </section>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Book;
